var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0165 1.12753e-05C9.77135 -0.00306585 7.57041 0.623744 5.6638 1.8092C3.75718 2.99465 2.22136 4.6912 1.2309 6.70601C0.240437 8.72082 -0.164941 10.9731 0.060843 13.2068C0.286627 15.4405 1.13451 17.5661 2.50814 19.342C3.88176 21.1178 5.72602 22.4727 7.83129 23.2526C9.93657 24.0326 12.2184 24.2063 14.4175 23.754C16.6166 23.3017 18.6447 22.2415 20.2712 20.6941C21.8978 19.1466 23.0577 17.1738 23.619 15H20.4975C19.9474 16.5558 18.9802 17.9304 17.7016 18.9736C16.4229 20.0168 14.8821 20.6883 13.2476 20.9148C11.613 21.1413 9.94767 20.9141 8.43356 20.2579C6.91944 19.6018 5.61487 18.542 4.66247 17.1944C3.71006 15.8468 3.14648 14.2633 3.03335 12.617C2.92021 10.9708 3.26188 9.32505 4.02098 7.85985C4.78009 6.39465 5.92742 5.16635 7.33754 4.30925C8.74766 3.45214 10.3663 2.99923 12.0165 3.00001C13.1968 3.00174 14.3649 3.23875 15.4525 3.69719C16.5402 4.15564 17.5255 4.82631 18.351 5.67001L13.524 10.5H24.024V1.12753e-05L20.4975 3.52501C19.3862 2.40703 18.0648 1.52 16.6092 0.915011C15.1536 0.310026 13.5927 -0.000946433 12.0165 1.12753e-05Z",
    fill: "#0073AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.e0c1499d01332bccea94fc7c45cf0bbb.svg";
export { ForwardRef as ReactComponent };